module.exports = __webpack_public_path__ + "img/hys-6.1167cfd5.webp";